var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    get statusCode() {
        return this.error.statusCode;
    }
    get notLogin() {
        return this.statusCode === 401;
    }
    get status() {
        if (this.statusCode === 200) {
            return 500;
        }
        if (this.notLogin) {
            return 'warning';
        }
        return this.statusCode;
    }
    get path() {
        return this.$route.path;
    }
    get query() {
        return this.$route.query;
    }
    get message() {
        // if (lodash.includes(this.error.message, "(reading 'path')")) {
        //   if (
        //     lodash.includes(this.path, this.$Mamba.EnumMicroApp.MicroPage) ||
        //     lodash.includes(this.path, this.$Mamba.EnumMicroApp.IframePage)
        //   ) {
        //     return "请在基座应用打开窗口";
        //   }
        // }
        return this.error.message;
    }
    onBackHome() {
        if (this.AppConfig.release && !this.AppConfig.ChildrenPage) {
            location.replace(this.$Link.workbench);
        }
        else {
            this.$router.replace('/');
        }
    }
    onReload() {
        window.location.reload();
    }
    mounted() {
        console.log(this);
    }
    updated() { }
    destroyed() { }
};
__decorate([
    Prop()
], default_1.prototype, "error", void 0);
default_1 = __decorate([
    Component({
        components: {},
    })
], default_1);
export default default_1;
